import * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResetPasswordWithOldPasswordMutationVariables = Types.Exact<{
  input: Types.ResetPasswordWithOldPasswordInput;
}>;


export type ResetPasswordWithOldPasswordMutation = { __typename?: 'RootMutationType', resetPasswordWithOldPassword: { __typename?: 'ResetPasswordResult', error?: string | null, success: boolean } };


export const ResetPasswordWithOldPasswordDocument = gql`
    mutation resetPasswordWithOldPassword($input: ResetPasswordWithOldPasswordInput!) {
  resetPasswordWithOldPassword(input: $input) {
    error
    success
  }
}
    `;
export type ResetPasswordWithOldPasswordMutationFn = Apollo.MutationFunction<ResetPasswordWithOldPasswordMutation, ResetPasswordWithOldPasswordMutationVariables>;

/**
 * __useResetPasswordWithOldPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordWithOldPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordWithOldPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordWithOldPasswordMutation, { data, loading, error }] = useResetPasswordWithOldPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordWithOldPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordWithOldPasswordMutation, ResetPasswordWithOldPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordWithOldPasswordMutation, ResetPasswordWithOldPasswordMutationVariables>(ResetPasswordWithOldPasswordDocument, options);
      }
export type ResetPasswordWithOldPasswordMutationHookResult = ReturnType<typeof useResetPasswordWithOldPasswordMutation>;
export type ResetPasswordWithOldPasswordMutationResult = Apollo.MutationResult<ResetPasswordWithOldPasswordMutation>;
export type ResetPasswordWithOldPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordWithOldPasswordMutation, ResetPasswordWithOldPasswordMutationVariables>;